module.exports = __webpack_public_path__ + "static/img/09018B_1_2_C_20240318_fit.f44886b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/09018B_1_2_C_20240318_fit.png
// module id = nlCh
// module chunks = 0